/**
 * ReserveConfirmationModal - Tipo 1: Modal de Confirmación
 */

import React from 'react';
import { Lock as LockIcon } from '@mui/icons-material';
import BlockActionConfirmationModal from './BlockActionConfirmationModal';

export interface ReserveConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (comment?: string) => void;
  itemName?: string;
  itemCode?: string;
  isLoading?: boolean;
  title?: string;
  message?: string;
}

const ReserveConfirmationModal: React.FC<ReserveConfirmationModalProps> = ({
  open,
  onClose,
  onConfirm,
  itemName,
  itemCode,
  isLoading = false,
  title = 'Confirmar bloqueo',
  message = '¿Bloquear esta pieza?',
}) => (
  <BlockActionConfirmationModal
    open={open}
    onClose={onClose}
    onConfirm={onConfirm}
    itemName={itemName}
    itemCode={itemCode}
    isLoading={isLoading}
    title={title}
    message={message}
    confirmText="Confirmar"
    loadingConfirmText="Bloqueando..."
    icon={<LockIcon />}
    commentPlaceholder="Ej: Pieza en revisión, reservada para cliente, etc."
  />
);

export default ReserveConfirmationModal;
